var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73996 0.292893C9.13048 -0.0976311 9.76365 -0.0976311 10.1542 0.292893C10.5447 0.683418 10.5447 1.31658 10.1542 1.70711L4.70494 7.15634C4.31441 7.54687 3.68125 7.54687 3.29073 7.15634L0.292893 4.15851C-0.0976311 3.76798 -0.0976311 3.13482 0.292893 2.74429C0.683418 2.35377 1.31658 2.35377 1.70711 2.74429L3.99783 5.03502L8.73996 0.292893Z",
    fill: "#009A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9a6778cc527d8da55a916fb07aa947a4.svg";
export { ForwardRef as ReactComponent };